import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../contexts/auth/Context";
import { useToast } from "../../contexts/toast/Context";
import { changePasswordRequest } from "../requests/auth";

interface ChangePasswordVars {
  currentPassword: string;
  newPassword: string;
}

export const useChangePassword = () => {
  const { token, markPasswordChanged } = useAuth();
  const { showToast } = useToast();

  const { mutate, mutateAsync, isPending } = useMutation({
    mutationFn: (vars: ChangePasswordVars) =>
      changePasswordRequest(vars, token!),
    meta: { track: true, eventName: "auth:password-changed" },
    onSuccess: ({ mustAcceptTerms }) => {
      markPasswordChanged(mustAcceptTerms);
      showToast("Contraseña actualizada correctamente", "success");
    },
    onError: (err: Error) => {
      showToast(err.message ?? "Error al cambiar la contraseña", "error");
    },
  });

  return { mutate, mutateAsync, isPending };
};
